import React from 'react';
import { Form, Modal, Typography } from 'antd';
import type { HostTenantListItem } from '../../tenants/api/tenants';
import HostTenantLicenseFields, { type HostTenantLicenseFormValues } from './HostTenantLicenseFields';
import { toTenantLicenseRequest } from '../utils/licenseForm';
import type { TenantLicenseRequest } from '../../tenants/api/tenants';

const { Text } = Typography;

interface ApproveHostTenantModalProps {
  tenant: HostTenantListItem | null;
  open: boolean;
  saving: boolean;
  onClose: () => void;
  onApprove: (tenantId: string, license: TenantLicenseRequest) => void;
}

const ApproveHostTenantModal: React.FC<ApproveHostTenantModalProps> = ({
  tenant,
  open,
  saving,
  onClose,
  onApprove,
}) => {
  const [form] = Form.useForm<HostTenantLicenseFormValues>();

  function handleClose() {
    form.resetFields();
    onClose();
  }

  function handleFinish(values: HostTenantLicenseFormValues) {
    if (!tenant) {
      return;
    }

    onApprove(tenant.id, toTenantLicenseRequest(values));
  }

  return (
    <Modal
      title="Approve tenant"
      open={open}
      onCancel={handleClose}
      onOk={() => form.submit()}
      okText="Approve and send invite"
      confirmLoading={saving}
      destroyOnClose
    >
      {tenant && (
        <Text style={{ display: 'block', marginBottom: 16 }}>
          Activate <strong>{tenant.companyName}</strong> and send an invite to{' '}
          <strong>{tenant.primaryContactEmail}</strong>.
        </Text>
      )}
      <div className="cp-form-section">
        <Form form={form} layout="vertical" onFinish={handleFinish} initialValues={{ useDefaultTrial: true }}>
          <HostTenantLicenseFields />
        </Form>
      </div>
    </Modal>
  );
};

export default ApproveHostTenantModal;
